<template>
    <PageHeader :title="(moduleID) ? sprintf($t('pages.module.credentials.subTitle'), [this.module.name ?? '']) : $t('pages.module.credentials.subTitle')" back-to="/module"/>

    <el-form :model="form.data" ref="credentialsForm">
        <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body d-flex flex-column p-9">
                        <div class="row">
                            <template v-for="(item, index) in data" :key="index">
                                <div class="col-md-12 fv-row mb-1">
                                    <label class="fs-6 fw-bold mb-2">{{ item.title }}</label>
                                    <el-form-item>
                                        <el-input v-model="form.data[item.opt]" type="text"/>
                                    </el-form-item>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item class="m-0">
                                <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary w-100" type="button">
                                    <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                                    <span v-if="form.loading" class="indicator-progress">
                                        {{ $t("messages.wait") }}
                                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
import PageHeader from "@/components/page-header/PageHeader.vue";

export default {
    name: "credentials",
    components: {PageHeader},
    data() {
        return {
            tabModel: 'general',
            company: {},
            form: {
                loading: false,
                data: {},
            },
            data: {},
        }
    },
    computed: {
        moduleID() {
            return Number(this.$route.params.id);
        },
        module(){
            return this.$store.getters['company/module/moduleDetail'](this.moduleID);
        }
    },
    created() {
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("pages.module.credentials.title"), []);

        if ((this.moduleID && this.moduleID > 0) && this.module?.supported?.credentials) {
            this.fetchCredentials();
        } else {
            this.$router.push({
                path: "/module",
            });
        }
    },
    methods: {
        fetchCredentials(moduleID = this.moduleID) {
            this.$store.dispatch("company/module/credential", {
                moduleID: moduleID
            }).then((res) => {
                this.data = res.map(item => ({
                    ...item,
                    value: item.value ?? item.default
                }));

                res.map(item => {
                    this.form.data[item.opt] = item.value ?? item.default;
                });
            });
        },
        onSubmit() {
            this.$refs.credentialsForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    const credentials = Object.entries(this.form.data).map(([opt, value]) => ({
                        opt,
                        value
                    }))

                    if (this.moduleID) {
                        this.$store.dispatch('company/module/updateCredential', {
                            moduleID: this.moduleID,
                            credentials: credentials,
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    this.fetchCredentials();
                                });
                            }

                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            this.form.data = {};
            this.data = {};
        },
    },
    watch: {
        moduleID(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (!newValue) {
                    this.resetForm()
                }
            }
        }
    }
}
</script>

<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
</style>